
<template>
  <!--帖子管理-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey=""
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
      :scrollWidth='scrollWidth'
    >
      <template slot="opt_a" slot-scope="{row}">
        <template v-if="row.mediasList&&row.mediasList.length>0">

          <a @click ="showAttachment(row)" >查看</a>
        </template>
      </template>
      <template slot="opt_c" slot-scope="{row}">
        <a-tooltip :title="row.content">
          <div class="feed-over-text" >{{row.content}}</div>
        </a-tooltip>
      </template>
      <template slot="opt_o" slot-scope="{row}">
        <img @click="showAvatar(row.avatarUrl)" :style="{width: '30px', height: '30px'}" :src="row.avatarUrl" alt="">
      </template>
      <template slot="opt_r" slot-scope="{row}">
        <a-switch v-hasPermi="['']" @change="changeStatus(row,'r')" :checked="Number(row.recommend) ? true : false"/>
      </template>
      <template slot="opt_t" slot-scope="{row}">
        <a-switch v-hasPermi="['']" @change="changeStatus(row,'t')" :checked="Number(row.top) ? true : false"/>
      </template>
      <template slot="opt_status" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="statusColor[row.visible] + '-bg'"></span>
          <span>{{ statusObj[row.visible] }}</span>
        </div>
      </template>
    </x-tabula>
    <add ref='model' @updateTable = 'updateTable'></add>
    <media ref='media'></media>
  </div>
</template>

<script>
import add from './add.vue';
import media from './mediaBox.vue';
export default {
  name: 'postManage',
  components: {
    add, media
  },
  props: {
    tabType: {
      default: () => '1'
    }
  },
  data () {
    return {
      scrollWidth: { x: 2000 },
      statusColor: ['info', 'success'],
      statusObj: ['屏蔽', '公开'],
      searchList: [
        { props: ['keywords'], placeholder: '内容、ID', options: [], inputType: 'input' },
        { props: ['memberId'], placeholder: '发布人', options: [], inputType: 'input' },
        { props: ['createDate'], placeholder: ['发布时间', '发布时间'], options: [], inputType: 'datePick' },
        {
          props: ['visible'],
          placeholder: '状态',
          options: [
            {label: '屏蔽', value: 0},
            {label: '公开', value: 1}
          ],
          inputType: 'select'
        },
        {
          props: ['fileType'],
          placeholder: '帖子类型',
          options: [
            {label: '文字', value: 0},
            {label: '图文', value: 1},
            {label: '视频', value: 2}
          ],
          inputType: 'select'
        },
        {
          props: ['recommend'],
          placeholder: '推荐',
          options: [
            {label: '不推荐', value: 0},
            {label: '推荐', value: 1}
          ],
          inputType: 'select'
        },
        {
          props: ['top'],
          placeholder: '置顶',
          options: [
            {label: '非置顶', value: 0},
            {label: '置顶', value: 1}
          ],
          inputType: 'select'
        }
      ],
      searchParams: {
        keywords: undefined,
        memberId: undefined,
        visible: undefined,
        recommend: undefined,
        createDate: undefined,
        fileType: undefined,
        top: undefined
      },
      tableOptList: [],
      rowOptList: [
        {
          text: '编辑',
          handle: record => this.handleComplain(record, '编辑'),
          permi: ['community:housekeepCircle:edit']
        },
        {
          customRender: true,
          rowOptText: row => row.visible === 1 ? '屏蔽' : '公开',
          handle: record => this.handleComplain(record, '状态'),
          permi: ['community:housekeepCircle:change']
        }
      ],
      columns: [
        { title: '帖子ID', dataIndex: 'circleId', align: 'left', width: '' },
        { title: '头像', dataIndex: 'avatarUrl', align: 'left', width: '', scopedSlots: {customRender: 'o'} },
        { title: '手机号', dataIndex: 'mobilePhone', align: 'left', width: '' },
        { title: '昵称', dataIndex: 'nickName', align: 'left', width: '' },
        { title: '内容', dataIndex: 'content', align: 'left', width: '250px', scopedSlots: {customRender: 'c'} },
        { title: '类型', dataIndex: 'fileTypeDesc', align: 'left', width: '' },
        { title: '附件', dataIndex: '', align: 'left', width: '', scopedSlots: {customRender: 'a'} },
        { title: '隶属', dataIndex: 'channelName', align: 'left', width: '' },
        { title: '话题', dataIndex: 'topicName', align: 'left', width: '' },
        { title: '评价数', dataIndex: 'commentsCount', align: 'left', width: '' },
        { title: '点赞数', dataIndex: 'praiseCount', align: 'left', width: '' },
        { title: '发布时间', dataIndex: 'createTime', align: 'left', width: '200px' },
        { title: '排序', dataIndex: 'sort', align: 'left', width: '' },
        { title: '推荐', dataIndex: 'recommend', align: 'left', width: '', scopedSlots: {customRender: 'r'}},
        { title: '置顶', dataIndex: 'top', align: 'left', width: '', scopedSlots: {customRender: 't'} },
        { title: '状态', dataIndex: 'visible', align: 'left', width: '', scopedSlots: {customRender: 'status'}},
        { title: '操作', dataIndex: 'action', align: 'left', width: '', fixed: 'right', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/housekeep/circles',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        title: ''
      },
      deleteParam: {
        url: '',
        param: {pk_key: '', pk_val: ''},
        title: '',
        key: ''
      }
    };
  },
  created () {
  },
  methods: {
    updateTable (res) {
      if (res && res.code == 200) {
        this.$message.success(res.msg);
      }
      this.$refs.table.getTableList();
    },
    showAttachment (row) {
      this.$refs.media.show(row.mediasList, document.documentElement.scrollTop);
    },
    changeStatus (row, type) {
      let left = document.getElementsByClassName('ant-table-body')[0].scrollLeft;
      let param;
      if (type == 'r') {
        param = {
          recommend: row.recommend == 0 ? 1 : 0
        };
      } else if (type == 't') {
        param = {
          top: row.top == 0 ? 1 : 0
        };
      }
      this.$put({
        url: `/housekeep/circles/${row.circleId}`,
        params: param
      }).then(({data}) => {
        this.$message.success('操作成功！');
        this.$refs.table.getTableList();
        setTimeout(() => {
          document.getElementsByClassName('ant-table-body')[0].scrollTo(left, 0);
        }, 300);
      });
    },
    handleComplain (row, type) {
      let left = document.getElementsByClassName('ant-table-body')[0].scrollLeft;

      if (type == '状态') {
        this.$put({
          url: `/housekeep/circles/change/${row.circleId}`,
          params: {
            visible: row.visible == 0 ? 1 : 0
          }
        }).then(({data}) => {
          this.$message.success('状态切换成功！');
          this.$refs.table.getTableList();
          setTimeout(() => {
            document.getElementsByClassName('ant-table-body')[0].scrollTo(left, 0);
          }, 300);
        });
      }
      if (type === '编辑') {
        this.$refs.model.show(row);
      }
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }

};
</script>

<style scoped>
::v-deep .ant-table-body::-webkit-scrollbar{height:4px;}
::v-deep .ant-table-body::-webkit-scrollbar-track{border-radius:5px;background:rgb(249, 249, 249);}
::v-deep .ant-table-body::-webkit-scrollbar-thumb{border-radius:5px;background:rgba(222, 222, 222);}
::v-deep .ant-table-body::-webkit-scrollbar-thumb:hover{background:rgba(102,102,102,.6);}
::v-deep .ant-table-body::-webkit-scrollbar-thumb:active{background:rgba(102,102,102,.6);}
</style>
